import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Fade } from "react-bootstrap";
import toast from "react-hot-toast";

import { GetEmbeddings, SaveProgramSummary, SendQuery } from "../../redux/embeddings/actions";

import CustomTableV2 from "../../common/CustomTableV2";
import CustomButton from "../../common/CustomButton";

import "./style.css";

function Embeddings(props) {

    const [list, setList] = useState([]);
    const [listFix, setListFix] = useState(null);
    const [testResult, setTestResult] = useState(null);
    const [query, setQuery] = useState("");

    useEffect(() => {
        if (list.length && !listFix) {
            setListFix([...list]);
        }
    }, [list]);

    const updateList = (i, value) => {
        const temp = [...list];
        temp[i] = {
            ...temp[i],
            summary: value,
            changed: true
        };
        setList([...temp]);
    }

    const saveProgramSummary = (i) => {
        let temp = [...list];
        if (!temp[i]?.submitting) {
            temp[i] = {
                ...temp[i],
                submitting: true,
            };
            setList([...temp]);

            props.SaveProgramSummary(temp[i])
                .then((res) => {
                    if (res?.success) {
                        let temp = list.map((item) => {
                            return {
                                ...item,
                                submitting: false,
                                changed: false,
                            }
                        });
                        setList([...temp]);
                        toast.success("Saved!");
                    } else {
                        toast.error("Failed!")
                    }
                })
                .catch((err) => {
                });
        }
    }

    const sendQuery = () => {
        props.SendQuery(query)
            .then((res) => {
                if (res?.success) {
                    setTestResult(res.results);
                }
            })
            .catch((err) => {
            });
    }



    return (
        <>
            <Fade in>
                <div id="embeddings-panel" className="main-container">
                    <div>

                        <div id="ep-summary">

                            <CustomTableV2
                                title="PROGRAM SUMMARY"
                                description="Overview of Program Summary."
                                store={{ list: list }}
                                table={{
                                    headers: [
                                        { title: "" },
                                    ],
                                    body: (program, i) => {
                                        return (
                                            <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                                <td>
                                                    <h5>{program.program.toUpperCase()}</h5>
                                                    <textarea type="text" value={program.summary} onChange={(e) => {
                                                        updateList(i - 1, e.target.value);
                                                    }} />
                                                    <CustomButton onClick={() => {
                                                        saveProgramSummary(i - 1);
                                                    }} disabled={(!program.changed)}>SAVE</CustomButton>
                                                </td>
                                            </tr>
                                        )
                                    }
                                }}
                                actions={{
                                    get: async (page, count, filter, sort) => {
                                        let res = await props?.GetEmbeddings();
                                        setList([...res]);
                                    }
                                }}
                                withPagination={false}
                                withSearch={false}
                            />
                        </div>

                        <div id="ep-query">
                            <div id="embeddings-query-area">
                                <h4>QUERY</h4>
                                <textarea type="text" value={query} onChange={(e) => {
                                    setQuery(e.target.value);
                                }} />

                                <CustomButton onClick={() => {
                                    setTestResult(null);
                                    sendQuery();
                                }}>TEST</CustomButton>

                                {
                                    testResult &&
                                    <div id="embeddings-query-result-area">
                                        <h5>RESULT</h5>
                                        {
                                            testResult.map((item, i) => {
                                                return (
                                                    <p>{i + 1} - {item?.program}</p>
                                                )
                                            })
                                        }
                                    </div>
                                }

                            </div>

                        </div>
                    </div>
                </div>
            </Fade>
        </>
    );
}

const mapStateToProps = (state) => ({
    Embeddings: state.Embeddings
})

export default connect(mapStateToProps, {
    GetEmbeddings,
    SaveProgramSummary,
    SendQuery,
})(Embeddings);
